// Recherche libre du design system — le pendant logique de NdoeRecherche.
//
// POURQUOI CE FICHIER : la campagne « recherche unifiée » veut que la recherche
// s'apprenne UNE seule fois. Le composant unifie l'apparence ; sans un helper
// partagé, chaque page réinventait son filtre — et la plupart se contentaient
// d'un OU sur deux ou trois champs, ce qui rend la zone libre inutilisable dès
// qu'on tape deux mots.
//
// RÈGLE : plusieurs mots = ET. « nadine impayée » trouve les dettes impayées de
// Nadine. C'est le ET qui rend la zone combinable, donc utile — un OU ramènerait
// tout ce qui contient « nadine » OU « impayée », c'est-à-dire presque tout.
// À l'intérieur d'un mot, on cherche dans TOUS les champs déclarés à la fois.

/**
 * Construit un prédicat de filtrage à partir d'une liste de champs.
 *
 * @param {string} q       texte libre saisi
 * @param {Array}  champs  noms de propriétés, ou fonctions (item) => valeur
 *                         pour les valeurs calculées (pointure « P38 », etc.)
 * @returns {(item) => boolean}
 */
export const filtreTexte = (q, champs) => {
  const mots = String(q || '').toLowerCase().split(/\s+/).filter(Boolean);
  return (item) => {
    if (!mots.length) return true;
    if (!item) return false;
    const foin = champs
      .map((c) => {
        try { return typeof c === 'function' ? c(item) : item[c]; } catch (e) { return null; }
      })
      .filter((v) => v !== null && v !== undefined && v !== '')
      .join(' ')
      .toLowerCase();
    return mots.every((m) => foin.includes(m));
  };
};

/**
 * Options d'une facette, construites depuis les données DÉJÀ reçues.
 * Zéro appel serveur supplémentaire, et la liste colle toujours à ce qui est
 * affiché : on ne propose jamais un filtre qui ne ramènerait rien.
 *
 * @param {Array} data    lignes affichées
 * @param {string|Function} champ  propriété ou extracteur
 */
export const optionsDe = (data, champ) => {
  const vues = new Set();
  (data || []).forEach((item) => {
    const v = typeof champ === 'function' ? champ(item) : (item || {})[champ];
    if (v !== null && v !== undefined && String(v).trim() !== '') vues.add(String(v));
  });
  return [...vues].sort((a, b) => a.localeCompare(b, 'fr', { numeric: true }))
    .map((v) => ({ value: v, label: v }));
};

/** Compte les filtres actifs — pilote l'affichage du bouton « Effacer ». */
export const compterActifs = (...valeurs) => valeurs.filter(
  (v) => v !== null && v !== undefined && v !== '' && !(Array.isArray(v) && !v.length),
).length;
